import * as React from 'react';
import PageModel from '@app/Model/PageModel';
import { PageSection, Title } from '@patternfly/react-core';
import AccordionComponent from '@app/Components/Page/AccordionComponent';
import htmlParser from '@app/utils/htmlParser';

interface GeneralPageProps {
    pageData: PageModel,
}

const GeneralPage: React.FC<GeneralPageProps> = ({ pageData, children }) => {

    return (
        <>
            <PageSection>
                <Title headingLevel="h1" className="pf-u-mb-md">{pageData.title}</Title>
                <div className="pf-c-content">
                    {htmlParser.htmlToJSX(pageData.content)}
                </div>
                {children}
            </PageSection>
            {pageData.acf.accordions && <AccordionComponent accordions={pageData.acf.accordions} />}
        </>
    )

};

export default GeneralPage;